 
    import { Prop } from 'vue-property-decorator';  
    import { Options, Vue  } from "vue-class-component";   
    import { useI18n } from "vue-i18n";

    @Options({
        name: "CadastroInline",
        components: {  },  
    }) 
    export default class  CadastroInline extends Vue { 
        
        @Prop( ) readonly processando!: any 
        @Prop( ) readonly titulo!: any 
        @Prop( ) readonly headerhidden!: boolean 

        private t = useI18n().t;
        private te = useI18n().te; 
        public translate = text => {
            if (this.te(text)) {
                return this.t(text);
            } else {
                return text;
            } 
        }
    } 
